import { inject } from "@angular/core";
import { Router } from "@angular/router";
import { UserCustomizationService } from "@onsip/common/services/api/resources/userCustomization/user-customization.service";

import { map } from "rxjs/operators";
import { views } from "@onsip/web/app/phone/views";

export const SaysoAnalyticsGuard = () => {
  const userCustomization = inject(UserCustomizationService);
  const router = inject(Router);

  return userCustomization.selfUser.pipe(
    map(userCustomState => {
      if (userCustomState?.userInfo?.sayso?.showAnalytics) {
        return true;
      } else {
        router.navigate([views.SAYSO_VIEW]);
        return false;
      }
    })
  );
};
